import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ENTRY_KINDS, TAG_KINDS, TAG_KIND_ORDER } from '@/lib/kinds'
import BrandLogo from '@/components/kb/brand-logo'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t-[3px] border-foreground bg-card'>
            <div className='mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr_1fr]'>
                <div className='flex flex-col gap-4'>
                    <BrandLogo />

                    <p className='max-w-xs text-sm leading-relaxed text-muted-foreground'>
                        A searchable library of the Geo Vastu teachings of Dr. Rajendra Jain: vastu, interior vastu, swar vigyan, muhurta and forecasting, organised by samagri, event, place and goal.
                    </p>
                </div>

                <div>
                    <p className='mb-3 font-mono text-xs font-bold uppercase tracking-widest'>
                        Library
                    </p>

                    <ul className='flex flex-col gap-2 text-sm'>
                        {ENTRY_KINDS.slice(0, 7).map(meta => (
                            <li key={meta.kind}>
                                <Link href={`/library?kind=${meta.kind}`} className='text-muted-foreground hover:text-foreground hover:underline'>
                                    {meta.plural}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className='mb-3 font-mono text-xs font-bold uppercase tracking-widest'>
                        Find by
                    </p>

                    <ul className='flex flex-col gap-2 text-sm'>
                        {TAG_KIND_ORDER.map(kind => (
                            <li key={kind}>
                                <Link href={TAG_KINDS[kind].path} className='text-muted-foreground hover:text-foreground hover:underline'>
                                    {TAG_KINDS[kind].label}
                                </Link>
                            </li>
                        ))}

                        <li>
                            <Link href='/library?kind=devta' className='text-muted-foreground hover:text-foreground hover:underline'>
                                Vastu Devtas
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className='mb-3 font-mono text-xs font-bold uppercase tracking-widest'>
                        Learn
                    </p>

                    <ul className='flex flex-col gap-2 text-sm'>
                        <li>
                            <Link href='/courses' className='text-muted-foreground hover:text-foreground hover:underline'>
                                All courses
                            </Link>
                        </li>

                        <li>
                            <Link href='/courses/video-library' className='text-muted-foreground hover:text-foreground hover:underline'>
                                Video library
                            </Link>
                        </li>

                        <li>
                            <Link href='/qa' className='text-muted-foreground hover:text-foreground hover:underline'>
                                Questions and answers
                            </Link>
                        </li>

                        <li>
                            <Link href='/search' className='text-muted-foreground hover:text-foreground hover:underline'>
                                Search
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className='border-t-2 border-foreground'>
                <div className='mx-auto flex max-w-6xl flex-col gap-2 px-4 py-5 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between sm:px-6'>
                    <p>
                        Compiled from class and video transcripts for study and reference.
                    </p>

                    <p className='font-mono'>
                        GeoVastu Gyan Kosh
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
